export const IN_APP_NOTIFICATIONS_MERGE = "in_app_notifications_merge";
export const IN_APP_NOTIFICATIONS_PUSH = "in_app_notifications_push";
export const IN_APP_NOTIFICATIONS_MARK_READ = "in_app_notifications_mark_read";
export const IN_APP_NOTIFICATIONS_MARK_ALL_READ = "in_app_notifications_mark_all_read";
